var _rect, _linearGradient, _linearGradient2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiaSuper6From49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: -0.169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#467d20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#5a942e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#6aa73a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#70ae3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adea53"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70ae3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#77b540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#8ac747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#a9e652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adea53"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "currentLayer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.271 39.407C8.947 39.018.704 30.484.704 20.007S8.947.982 19.271.593v38.814z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993.58c10.657 0 19.303 8.686 19.303 19.427 0 10.713-8.646 19.414-19.303 19.414-.236 0-.486-.014-.722-.014V.593c.236 0 .486-.014.722-.014z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 2.12c9.825 0 17.776 8.007 17.776 17.887 0 9.866-7.951 17.873-17.776 17.873-9.81 0-17.776-8.007-17.776-17.873 0-9.88 7.965-17.887 17.776-17.887z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 3.743c8.923 0 16.166 7.272 16.166 16.264 0 8.978-7.243 16.25-16.166 16.25S3.841 28.985 3.841 20.007c0-8.992 7.23-16.264 16.152-16.264z",
    fill: "#fcc92f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 8.142c6.508 0 11.781 5.315 11.781 11.865 0 6.536-5.273 11.85-11.78 11.85-6.495 0-11.782-5.314-11.782-11.85.014-6.55 5.287-11.865 11.781-11.865z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 12.125c4.33 0 7.84 3.525 7.84 7.882 0 4.343-3.51 7.868-7.84 7.868-4.316 0-7.826-3.525-7.826-7.868 0-4.357 3.51-7.882 7.826-7.882z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 13.665c3.483 0 6.3 2.831 6.3 6.342 0 3.497-2.817 6.328-6.3 6.328-3.47 0-6.286-2.831-6.286-6.328s2.817-6.342 6.286-6.342z",
    fill: "#041987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 15.206c2.623 0 4.76 2.137 4.76 4.8 0 2.638-2.137 4.788-4.76 4.788a4.774 4.774 0 0 1-4.76-4.787c0-2.65 2.137-4.801 4.76-4.801z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 16.76c1.776 0 3.22 1.457 3.22 3.247a3.233 3.233 0 0 1-3.22 3.233 3.233 3.233 0 0 1-3.22-3.233c0-1.79 1.444-3.247 3.22-3.247z",
    fill: "#6b6db6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 18.12c1.04 0 1.873.846 1.873 1.887a1.873 1.873 0 0 1-1.873 1.873 1.887 1.887 0 0 1-1.873-1.873 1.887 1.887 0 0 1 1.873-1.887z",
    fill: "#041987"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaSuper6From49);
export default __webpack_public_path__ + "static/media/india_super_6_from_49.9e345fb21eb5c932305caec03b58bff3.svg";
export { ForwardRef as ReactComponent };